import { cn as e } from "../../shared/utils.js";
import { Button as t } from "../../button/primitive/button.js";
import { useTranslation as n } from "../../i18n/hooks.js";
import { breakpointQueries as r } from "../../shared/breakpoints.js";
import { useMediaQuery as i } from "../../shared/hooks/use-media-query.js";
import { jsx as a, jsxs as o } from "react/jsx-runtime";
//#region src/date-picker/primitive/actions.tsx
function s({ applyDisabled: s, className: c, clearDisabled: l, onApply: u, onClear: d }) {
	let { t: f } = n(), p = i(r.isMobile, { initializeWithValue: !1 });
	return /* @__PURE__ */ o("div", {
		className: e("flex gap-1", c),
		children: [/* @__PURE__ */ a(t, {
			variant: "secondary",
			size: p ? "md" : "sm",
			className: "flex-1",
			disabled: l,
			onClick: d,
			children: f("public_pages_purchase.date_picker.clear")
		}), /* @__PURE__ */ a(t, {
			variant: "primary",
			size: p ? "md" : "sm",
			className: "flex-1",
			disabled: s,
			onClick: u,
			children: f("public_pages_purchase.date_picker.apply")
		})]
	});
}
//#endregion
export { s as Actions };
